// src/pages/PreInterviewSetup.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMyQuestions, startMockInterview } from "../api/mockClient";
import Layout from "../components/Layout";

export default function PreInterviewSetup() {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getMyQuestions();
        const items = Array.isArray(res.data) ? res.data : res.data.items || [];
        setCount(items.length);
      } catch (err) {
        console.error("Failed to load questions", err);
      }
    };
    load();
  }, []);

  const handleStart = async () => {
    setLoading(true);
    try {
      // start mixed (20 random) — backend expects { mode: "mixed" } or { mode: "domain", domain: "Cloud" }
      const res = await startMockInterview({ mode: "mixed" });
      const { interviewId, questions } = res.data;
      // navigate to interview page and pass questions in state
      navigate(`/prep/mock/${interviewId}`, { state: { questions } });
    } catch (err) {
      console.error("Start failed", err);
      alert(err?.response?.data?.error || "Failed to start interview");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="p-6">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-6">
          <h1 className="text-2xl font-bold mb-2">Mock Interview — Setup</h1>
          <p className="text-gray-600 mb-4">
            This mock interview will use <strong>20 questions</strong> from your saved question bank.
          </p>

          <div className="mb-4">
            <div className="text-sm text-gray-500 mb-1">Your saved questions</div>
            <div className="flex items-center gap-4">
              <div className="text-3xl font-semibold">{count}</div>
              <div className="flex-1">
                <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                  <div
                    className="h-3 bg-indigo-600"
                    style={{ width: `${Math.min(100, (count / 20) * 100)}%` }}
                  />
                </div>
                <div className="text-xs text-gray-500 mt-1">
                  {Math.min(count, 20)} of 20 required
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <button
              className={`px-4 py-2 rounded-lg text-white font-semibold ${
                count >= 20 ? "bg-indigo-600 hover:bg-indigo-700" : "bg-gray-400 cursor-not-allowed"
              }`}
              onClick={handleStart}
              disabled={count < 20 || loading}
            >
              {loading ? "Starting..." : "Start Mock Interview"}
            </button>

            <button
              className="px-4 py-2 rounded-lg border hover:bg-gray-50"
              onClick={() => navigate("/prep")} // ✅ use navigate instead of window.location.href
            >
              ← Back to Study Materials
            </button>
          </div>

          <p className="text-sm text-gray-500 mt-4">
            Tip: You can add questions at <code>/prep</code>. At least 20 are required to start.
          </p>
        </div>
      </div>
    </Layout>
  );
}
